import React from "react";
import { NavLink, useLocation } from "react-router-dom";

// ===== IMPORT ICONS =====
import homeIcon from "../assets/menu/home.svg";
import homeActiveIcon from "../assets/menu/home-active.svg";

import clubIcon from "../assets/menu/club.svg";
import clubActiveIcon from "../assets/menu/club-active.svg";

import learnIcon from "../assets/menu/learn.svg";
import learnActiveIcon from "../assets/menu/learn-active.svg";

import supportIcon from "../assets/menu/support.svg";
import supportActiveIcon from "../assets/menu/support-active.svg";

const Footer = () => {
  const location = useLocation();

  const items = [
    {
      title: "Главное",
      link: "/",
      icon: homeIcon,
      activeIcon: homeActiveIcon,
      isExternal: false,
    },
    {
      title: "Клуб",
      link: "/club",
      icon: clubIcon,
      activeIcon: clubActiveIcon,
      isExternal: false,
    },
    {
      title: "Обучение",
      link: "/Training",
      icon: learnIcon,
      activeIcon: learnActiveIcon,
      isExternal: false,
    },
    {
      title: "Поддержка",
      link: "https://t.me/innerart_bot",
      icon: supportIcon,
      activeIcon: supportActiveIcon,
      isExternal: true, // Флаг для внешней ссылки
    },
  ];

  const handleExternalClick = (e, url) => {
    e.preventDefault();
    // Открываем Telegram-бота в новом окне/вкладке
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 h-[72px]">
      <div className="h-full bg-gradient-to-r from-[#24104F] to-[#1B0B3A] flex items-center justify-between px-2 border-t border-white/10">

        {items.map((item, index) => {
          const isActive = location.pathname === item.link && !item.isExternal;

          // Выбираем форму иконки
          const iconShape = isActive ? item.activeIcon : item.icon;

          // Для внешних ссылок используем обычную кнопку
          if (item.isExternal) {
            return (
              <React.Fragment key={item.link}>
                <button
                  onClick={(e) => handleExternalClick(e, item.link)}
                  className="flex flex-col items-center justify-center w-full h-full pb-2 cursor-pointer"
                >
                  <div className="flex flex-col items-center gap-[4px]">

                    {/* ICON */}
                    <div className="relative w-[26px] h-[26px]">
                      <div
                        className="absolute inset-0"
                        style={{
                          background: "#AFADC9",
                          WebkitMaskImage: `url(${iconShape})`,
                          WebkitMaskRepeat: "no-repeat",
                          WebkitMaskPosition: "center",
                          WebkitMaskSize: "contain",
                          maskImage: `url(${iconShape})`,
                          maskRepeat: "no-repeat",
                          maskPosition: "center",
                          maskSize: "contain",
                        }}
                      />
                    </div>

                    {/* TEXT */}
                    <span className="text-[12px] leading-[12px] font-normal text-[#AFADC9]">
                      {item.title}
                    </span>

                  </div>
                </button>

                {/* Divider */}
                {index !== items.length - 1 && (
                  <div className="w-[1px] h-[36px] bg-white/10" />
                )}
              </React.Fragment>
            );
          }

          // Для внутренних ссылок используем NavLink
          return (
            <React.Fragment key={item.link}>
              <NavLink
                to={item.link}
                className="flex flex-col items-center justify-center w-full h-full pb-2"
              >
                <div className="flex flex-col items-center gap-[4px]">

                  {/* ICON */}
                  <div className="relative w-[26px] h-[26px]">
                    <div
                      className="absolute inset-0"
                      style={{
                        background: isActive
                          ? "linear-gradient(135deg, #6C6FF8 0%, #F466C8 100%)"
                          : "#AFADC9",
                        WebkitMaskImage: `url(${iconShape})`,
                        WebkitMaskRepeat: "no-repeat",
                        WebkitMaskPosition: "center",
                        WebkitMaskSize: "contain",
                        maskImage: `url(${iconShape})`,
                        maskRepeat: "no-repeat",
                        maskPosition: "center",
                        maskSize: "contain",
                      }}
                    />
                  </div>

                  {/* TEXT */}
                  <span
                    className={`text-[12px] leading-[12px] transition-all ${
                      isActive
                        ? "font-bold text-[#34D3FF]"
                        : "font-normal text-[#AFADC9]"
                    }`}
                  >
                    {item.title}
                  </span>

                </div>
              </NavLink>

              {/* Divider */}
              {index !== items.length - 1 && (
                <div className="w-[1px] h-[36px] bg-white/10" />
              )}
            </React.Fragment>
          );
        })}

      </div>
    </nav>
  );
};

export default Footer;